import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Typography,
  Snackbar,
  Alert, } from '@mui/material';
import axios from 'axios';
import env from "react-dotenv";

const EditMachineList = ({ open, handleClose, fetchMachines, report }) => {
  const [machineNo, setMachineNo] = useState(report.MachineNo);
  const [machineName, setMachineName] = useState(report.MachineName);
  const [startDate, setStartDate] = useState(report.startDate);
  const [endDate, setEndDate] = useState(report.endDate);
  const [productId, setProductId] = useState(report.productId);

  useEffect(() => {
    setMachineNo(report.MachineNo);
    setMachineName(report.MachineName);
    setStartDate(report.startDate);
    setEndDate(report.endDate);
    setProductId(report.productId);
  }, [report]);

  const handleUpdateMachine = () => {
    const updatedMachine = {
      MachineNo: machineNo,
      MachineName: machineName,
      startDate: startDate,
      endDate: endDate,
      productId: productId,
    };

    axios
      .put(`${process.env.REACT_APP_PJCBACKEND_URL}/api/machinelist/${report.id}`, updatedMachine)
      .then((response) => {
        fetchMachines();  // Refresh the machine list after updating
        handleClose();    // Close the dialog
      })
      .catch((error) => console.error('Error updating machine:', error));
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle><Typography variant="h6" align="center" gutterBottom>
        Edit Machine
        </Typography>
        </DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Machine ID"
          fullWidth
          value={machineNo}
          onChange={(e) => setMachineNo(e.target.value)}
          margin="normal"
        />
        <TextField
          label="Machine Name"
          fullWidth
          value={machineName}
          onChange={(e) => setMachineName(e.target.value)}
          margin="normal"
        />
        <TextField
          label="Start Date"
          fullWidth
          type="datetime-local"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          label="End Date"
          fullWidth
          type="datetime-local"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          label="Product ID"
          fullWidth
          value={productId}
          onChange={(e) => setProductId(e.target.value)}
          margin="normal"
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleUpdateMachine} color="primary">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditMachineList;
